import React from 'react'
import {Mutation} from 'react-apollo'

import CatalogPageController from './controller'
import updateCatalogSettingGql from './update-catalog-settings.graphql'

const CatalogPageWithMutation = (props) => {
  return <Mutation mutation={updateCatalogSettingGql} ignoreResults={true}>
    {(updateCatalogSettings) => <CatalogPageController {...props} updateCatalogSettings={updateCatalogSettings}/>}
  </Mutation>
}

export default CatalogPageWithMutation


